<template>
    <div id="location_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="locationHeader" v-if="$route.params.id > 0">Update Location</span>
                    <span class="page-title" id="locationHeader" v-else>Add Location</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackLocationList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content location-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="LocationForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group mt-4">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="is_rental" id="is_rental" name="is_rental">  Is Rental
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="is_job" id="is_job" name="is_job">  Is Job
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col form-group mt-4">
                                      <div class="custom-checkbox">
                                          <label class="checkbox-custom"> <input type="checkbox" v-model="is_insurance" id="is_insurance" name="is_insurance">  Is Insurance
                                          <span class="checkmark"></span>
                                          </label>
                                      </div>
                                  </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="company_name">Name:</label>
                                        <input type="text" class="form-control" v-model="company_name" id="company_name" placeholder="Enter Company Name" name="company_name">
                                        <div class="field-error">{{company_name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label :class="'control-label '+requireClass" for="phone">Phone:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="phone" id="phone" placeholder="999-999-9999" name="phone">
                                        <!-- <input-mask id="phone" :alwaysShowMask="true" name="phone" v-model="phone" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{phone_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label :class="'control-label '+requireClass" for="email">Email:</label>
                                        <input type="text" class="form-control" v-model="email" id="email" placeholder="Enter Email Address" name="email">
                                        <div class="field-error">{{email_error_msg}}</div>
                                    </div>
                                    <div v-if="isRentalChecked === true" class="col form-group">
                                        <label :class="'control-label '+requireClass" for="location_link">Location Link:</label>
                                        <input type="text" class="form-control" v-model="locationLink" id="location_link" placeholder="Enter Location Link" name="location_link">
                                        <div class="field-error">{{location_link_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="address_line_1">Address Line 1:</label>
                                        <input type="text" class="form-control" v-model="addressLine1" id="address_line_1" placeholder="Enter Address Line 1" name="address_line_1">
                                        <div class="field-error">{{address_line_1_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="address_line_2">Address Line 2:</label>
                                        <input type="text" class="form-control" v-model="addressLine2" id="address_line_2" placeholder="Enter Address Line 2" name="address_line_2">
                                        <div class="field-error">{{address_line_2_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="mobile">Mobile:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="mobile" id="mobile" placeholder="999-999-9999" name="mobile">
                                        <!-- <input-mask id="mobile" :alwaysShowMask="true" name="mobile" v-model="mobile" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{mobile_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">State:</label>
                                        <v-select v-model="state" name="state"
                                                label="text" :filterable="false" :options="stateArr"
                                                @search="onSearchState"
                                                placeholder="Select State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search State...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{state_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="city_id">City:</label>
                                        <a href="javascript:void(0)" v-on:click="addNewCity()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add City</a>
                                        <v-select v-model="city_id" name="city_id"
                                                label="text" :filterable="false" :options="cityArr"
                                                @search="onSearchCity"
                                                placeholder="Select City" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search City...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{city_error_msg}}</div>
                                        <template v-if="canAddCity">
                                          <div class="citycreate wo-vendorinv-form" >
                                              <city-add-form :id="'addCity'" v-on:populateCityId="popCityName($event)" class="citycreate wo-vendorinv-panel"></city-add-form>
                                          </div>
                                    </template>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Zip:</label>
                                        <input type="text" id="zip" name="zip" placeholder="Enter Zip Code" class="form-control" v-model="zip">
                                        <div class="field-error">{{zip_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="bay">Bay:</label>
                                        <input type="text" class="form-control" v-model="bay" id="bay" placeholder="Enter Number of Bay" name="bay">
                                        <div class="field-error">{{bay_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description"  name="description">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="module">TimeZone:</label>
                                        <v-select v-model="selectTimeZone" name="selectTimeZone" placeholder="Select TimeZone."
                                                label="text"
                                                :options="timezoneArr">
                                        </v-select>
                                        <div class="field-error">{{timezone_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="description">AFT:</label>
                                        <input type="text" class="form-control" v-model="aft" id="aft" placeholder="Enter AFT"  name="aft" @keypress="amountFormat($event)">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="diesel_tax">Diesel Tax:</label>
                                        <input type="text" class="form-control" v-model="diesel_tax" id="diesel_tax" placeholder="Enter Diesel Tax"  name="diesel_tax" @keypress="amountFormat($event)">
                                    </div>
                                    <div v-if="isRentalChecked === true" class="col form-group">
                                      <label :class="'control-label '+requireClass" for="latitude">Latitude:</label>
                                      <input type="text" class="form-control" v-model="latitude" id="latitude" placeholder="Enter Latitude"  name="latitude">
                                      <div class="field-error">{{latitude_error_msg}}</div>
                                    </div>
                                    <div v-if="isRentalChecked === true" class="col form-group">
                                      <label :class="'control-label '+requireClass" for="longitude">Longitude:</label>
                                      <input type="text" class="form-control" v-model="longitude" id="longitude" placeholder="Enter Longitude"  name="longitude">
                                      <div class="field-error">{{longitude_error_msg}}</div>
                                    </div>

                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createLocationBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateLocation" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createLocationBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateLocation" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueLocationBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateLocation(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelGroupBtn" class="btn btn-tertiary" v-on:click.prevent="BackLocationList" >
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask);
import CityCreate from '@/components/CityCreate.vue';
Vue.component("city-add-form", CityCreate);
export default {
  name: "LocationCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Location | " +process.env.COPYRIGHT_NAME : "Create Location | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    isRentalChecked: false,
    canAddCity:false,
    permissions: [],
    cantAccessPage: "",
    company_name: "",
    code: "",
    description: "",
    selectTimeZone: null,
    timezoneArr: [],
    loading:false,
    company_name_error_msg: "",
    code_error_msg: "",
    timezone_error_msg: "",
    state: null,
    stateArr: [],
    state_error_msg: "",
    bay: "",
    bay_error_msg: "",
    city_id: null,
    cityArr: [],
    city_error_msg: "",
    addressLine1: "",
    address_line_1_error_msg: "",
    addressLine2: "",
    address_line_2_error_msg: "",
    zip: "",
    zip_error_msg:"",
    locationLink:"",
    location_link_error_msg:"",
    mobile:"",
    mobile_error_msg:"",
    phone:"",
    phone_error_msg:"",
    email:"",
    email_error_msg:"",
    is_rental:false,
    is_job:false,
    is_insurance:false,
    diesel_tax:'',
    latitude:'',
    latitude_error_msg: '',
    longitude:'',
    longitude_error_msg: '',
    aft:'',
    requireClass:''
  }),
  watch:{

      //check permission change
      permissions: function (permissions) {

          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_location') {
                      self.cantAccessPage = true;
                  }
              }
          }

      },

      //if state value update after then change the city value also update that in thie module.
        state: function(state) {

            var self = this;

            if(self.state == null){
                self.city_id = "";
                self.cityArr = [];
            }
        },

        is_rental: function(marked) {
            var self = this;
            if ( marked == true ) {
                self.requireClass = 'require';
                self.isRentalChecked = true;
            } else {
                self.requireClass = '';
                self.isRentalChecked = false;
            }
        }


  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadTimeZone();
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadLocation();
            }
        }, 100);
  },
  methods: {

    popCityName(cid){

        console.log("check"+cid);
        // this.city_id =cid;
         this.city_id = {value: cid.id, text: cid.name};
    },
    onSearchState(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'state', '');
        }
    },

    onSearchCity(search, loading) {

        var self = this;
        if (search.length > 2) {

            var stateId = self.state.value;
            if ( stateId == "" ) {
                alert("please select state first");
                return;
            }

            loading(true);
            self.searchField(loading, search, 'city', '');
        }
    },

    BackLocationList() {
      var self = this;
      self.$router.push("/location/list");
    },

    loadTimeZone(){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/get-timezones",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            success: function (data) {
                //console.log(data.content.email);
                if (data.status == "success") {

                    self.timezoneArr = data.content;
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'loc-get-timezone')
            }
        });

    },

    CreateLocation(flag) {
      var self = this;
      var error = false;

      self.code = self.code.trim();
      self.company_name = self.company_name.trim();

      self.company_name_error_msg = "";
      self.code_error_msg = "";
      self.timezone_error_msg = "";
      self.email_error_msg = "";
      self.address_line_1_error_msg = "";
      self.state_error_msg = "";
      self.bay_error_msg = "";
      self.city_error_msg = "";
      self.zip_error_msg = "";
      self.phone_error_msg = "";
      self.mobile_error_msg = "";
      var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

      if (!self.company_name || self.company_name == null || self.company_name == "") {
        self.company_name_error_msg = "Name is required.";
        error = true;
      }

      if ( self.is_rental == true && (!self.email || self.email == null || self.email == "") ) {
        self.email_error_msg = "Email is required.";
        error = true;
      }
      // if ( self.is_rental == true && (!self.phone || self.phone == null || self.phone == "___-___-____") ) {
      //   self.phone_error_msg = "Phone is required.";
      //   error = true;
      // }
      if ( self.is_rental == true && (!self.latitude || self.latitude == null) ) {
        self.latitude_error_msg = "Latitude is required.";
        error = true;
      }
      if ( self.is_rental == true && (!self.longitude || self.longitude == null) ) {
        self.longitude_error_msg = "Longitude is required.";
        error = true;
      }
      // if ( self.phone != "___-___-____" && self.phone != null  && !self.phone.match(phoneRE)){
      //   self.phone_error_msg = "Phone must be in proper format";
      //   error = true;
      // }
      if (!self.zip || self.zip == null || self.zip == "") {
        self.zip_error_msg = "Zip is required.";
        error = true;
      }
       if(self.zip && (self.zip.length > 5 || self.zip.length < 5) ){
        self.zip_error_msg = "Zip Must Consist of 5 Digits";
        error = true;
      }
      if (!self.addressLine1 || self.addressLine1 == null || self.addressLine1 == "") {
        self.address_line_1_error_msg = "Address Line 1 is required.";
        error = true;
      }
      if (self.state == null || !self.state.value) {
        self.state_error_msg = "State is required.";
        error = true;
      }
    //   if (!self.bay || self.bay == null || self.bay == "") {
    //     self.bay_error_msg = "Bay is required.";
    //     error = true;
    //   }
      if (self.city_id == null || !self.city_id.value) {
        self.city_error_msg = "City is required.";
        error = true;
      }

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code is required.";
        error = true;
      }

      if (self.selectTimeZone == null || !self.selectTimeZone.value) {
        self.timezone_error_msg = "Time Zone is required.";
        error = true;
      }

      if(self.mobile && self.mobile != "___-___-____" && !self.mobile.match(phoneRE)){
        self.mobile_error_msg = "Mobile must be in proper format";
        error = true;
      }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createLocationBtn").val("Updating ...");
                $("#createLocationBtn").prop("disabled", true);
                $("#cancelGroupBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueLocationBtn").val("Saving ...");
                    $("#createLocationBtn").prop("disabled", true);
                    $("#createAndContinueLocationBtn").prop("disabled", true);
                    $("#cancelGroupBtn").prop("disabled",true);

                }else{

                    $("#createLocationBtn").val("Saving ...");
                    $("#createLocationBtn").prop("disabled", true);
                    $("#createAndContinueLocationBtn").prop("disabled", true);
                    $("#cancelGroupBtn").prop("disabled",true);
                }

            }
            var fields = $('#LocationForm').serializeArray();
            fields.push({name: "timezone", value: self.selectTimeZone.value});
            fields.push({name: "city_id", value: self.city_id.value});
            fields.push({name: "state_id", value: self.state.value});
            if ( self.is_rental == true ) {
                fields.push({name: "is_rental", value: 1});
            }else{
                fields.push({name: "is_rental", value: 0});
            }
            if ( self.is_job == true ) {
                fields.push({name: "is_job", value: 1});
            }else{
                fields.push({name: "is_job", value: 0});
            }
            if ( self.is_insurance == true ) {
                fields.push({name: "is_insurance", value: 1});
            }else{
                fields.push({name: "is_insurance", value: 0});
            }
            if ( self.phone != "___-___-____" ) {
                fields.push({name: "phone", value: self.phone});
            }else{
                fields.push({name: "phone", value: ""});
            }
            if (self.mobile != "___-___-____") {
                fields.push({name: "mobile", value: self.mobile});
            }else{
                fields.push({name: "mobile", value: ""});
            }

            fields.push({name: "id", value: segments[3]});


            $.ajax({
                url: process.env.ROOT_API + "/location/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createLocationBtn").val("Update");
                        $("#createLocationBtn").prop("disabled", false);
                        $("#cancelGroupBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueLocationBtn").val("Save and Continue");
                            $("#createLocationBtn").prop("disabled", false);
                            $("#createAndContinueLocationBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }else{

                            $("#createLocationBtn").val("Save");
                            $("#createLocationBtn").prop("disabled", false);
                            $("#createAndContinueLocationBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#LocationForm").trigger("reset");
                            self.company_name ="";
                            self.code = "";
                            self.bay = "";
                            self.description = "";
                            self.selectTimeZone = null;
                            self.state = null;
                            self.city = null;
                            self.aft = '';
                            self.diesel_tax = '';
                            self.addressLine1 = '';
                            self.addressLine2 = '';
                            self.locationLink = '';
                            self.zip = '';
                            self.latitude = '';
                            self.longitude = '';

                        }else{
                            self.$router.push("/location/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";

                            for (var i = 0; i < data.content.length; i++) {

                                if (data.content[i] == "The company name has already been taken."){
                                    err += "The name has already been taken." + "<br>";
                                } else{
                                    err += data.content[i] + "<br>";
                                }
                            }

                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createLocationBtn").val("Update");
                        $("#createLocationBtn").prop("disabled", false);
                        $("#cancelGroupBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#LocationForm").trigger("reset");


                            $("#createAndContinueLocationBtn").val("Save and Continue");
                            $("#createLocationBtn").prop("disabled", false);
                            $("#createAndContinueLocationBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }else{

                            $("#createLocationBtn").val("Save");
                            $("#createLocationBtn").prop("disabled", false);
                            $("#createAndContinueLocationBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'location-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }

    },

    loadLocation() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/location/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);

                if (data.status == "success") {
                    self.company_name = data.content.company_name;
                    self.mobile = data.content.mobile;
                    self.phone = data.content.phone;
                    self.email = data.content.email;
                    self.bay = data.content.bay_count;
                    self.locationLink = data.content.location_link;
                    self.addressLine1 = data.content.address_line_1;
                    self.addressLine2 = data.content.address_line_2;
                    self.zip = data.content.zip;
                    self.code = data.content.code;
                    self.description = data.content.description;
                    if(data.content.timezone == null){
                        self.selectTimeZone = null
                    }else{
                        self.selectTimeZone = {value: data.content.timezone, text: data.content.tzName};
                    }

                    if(data.content.city_id == null){
                        self.city_id = null;
                    }else{
                        self.city_id = {value: data.content.city_id, text: data.content.city};
                    }

                    if(data.content.state_id == null){
                        self.state = null;
                    }else{
                        self.state = {value: data.content.state_id, text: data.content.state};
                    }

                    if(data.content.is_rental == 1){
                        self.is_rental = true;
                    }else{
                        self.is_rental = false;
                    }
                    if(data.content.is_job == 1){
                        self.is_job = true;
                    }else{
                        self.is_job = false;
                    }
                    if(data.content.is_insurance == 1){
                        self.is_insurance = true;
                    }else{
                        self.is_insurance = false;
                    }
                    self.aft = data.content.aft;
                    self.diesel_tax = data.content.diesel_tax;
                    self.latitude = data.content.latitude;
                    self.longitude = data.content.longitude;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'location-by-id')
            }
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LocationCreate.vue